export default "__VITE_ASSET__Ccv_FhPq__"